export const sessionTerminationMessages = {
  LoggedInFromAnotherDevice: 'Session terminated. You have logged into your account from another device.',
};
